import { FC } from 'react';

import styled from '@mint-lib/styled';

import { Truncation } from '@myn/mui';

import { EXPANDER_WIDTH } from './NameTextField.jsx';

type Props = {
  value: string;
  width: number;
  scale: number;
};

const PredictivePlanningRowNameField: FC<Props> = ({ value, width, scale }) => {
  return (
    <TruncatedValue width={width} tooltipTitle={value} scale={scale}>
      {value}
    </TruncatedValue>
  );
};

export default PredictivePlanningRowNameField;

const TruncatedValue = styled(Truncation)<{
  width: number;
  scale: number;
}>`
  color: ${({ theme }) => theme.palette.text.link};
  text-transform: none;
  max-width: ${({ width }) => `${width - EXPANDER_WIDTH}px`};
  font-size: ${({ scale }) => `${0.875 * scale}rem`};
  line-height: ${({ scale }) => `${1 * scale}rem`};
  padding-left: ${({ scale }) => `${8 * scale}px`};
  text-transform: capitalize;
`;
